export function formatCurrency(value: number) {
  const pesosFormatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  })

  return pesosFormatter.format(value)
}
